<template>
  <block style="padding-bottom: 60px;">
    <template slot="header">
      <span style="color: #449D7A;">Atención finalizada exitosamente</span>
    </template>
    <div>
      <p class="question">¿Desea agregar una nueva atención para el estudiante?</p>
      <div class="action">
        <button class="button is-primary" @click="navigateTo('app.profile.add_attention')">
          Sí, agendar atención
        </button>
        &nbsp;
        <button class="button" @click="navigateTo('app.profile.attentions')">No, volver</button>
      </div>
    </div>
  </block>
</template>

<script>
import Block from "@/components/_base/Block.vue"
import OverlayedMixin from "@/mixins/OverlayedMixin"

export default {
  name: "ProfileAttentionFinished",
  mixins: [OverlayedMixin],
  components: {
    Block
  },
  methods: {
    navigateTo(route) {
      console.log(`Navigating to...${route}`)
      this.$emit("hello", route)
    }
  }
}
</script>

<style scoped>
.question {
  padding-bottom: 20px;
  margin-bottom: 40px;
  border-bottom: 1px solid #e0e0e0;
}
</style>
